<template>
  <div>
    <v-select
      :items="items"
      :style="{ width: width + 'px' }"
      color="primaryText"
      :prepend-inner-icon="prependIcon"
      :label="label"
      v-model="model"
      @change="changeHandler"
      :item-text="itemText"
      :item-value="itemValue"
      :return-object="returnObject"
      hide-details
      hide-selected
      box
      :background-color="$vuetify.theme.bg"
    >
    </v-select>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selection: Number | String,
    label: String,
    itemText: String,
    itemValue: String,
    returnObject: {
      type: Boolean,
      default: false,
    },
    width: Number | String,
    prependIcon: String,
  },
  data() {
    return {
      model: null,
    };
  },
  mounted() {
    this.selectionHandler();
  },
  methods: {
    selectionHandler() {
      if (!isNaN(this.selection)) {
        const index = +this.selection;
        this.model = this.items[index];
      } else {
        this.model = this.selection;
      }
    },
    changeHandler() {
      this.$emit("change", this.model);
    },
  },
  watch: {
    selection() {
      this.selectionHandler();
    },
  },
};
</script>
